import { render, staticRenderFns } from "./HomeFeaturesTokens.vue?vue&type=template&id=95da436a&scoped=true"
import script from "./HomeFeaturesTokens.vue?vue&type=script&lang=js"
export * from "./HomeFeaturesTokens.vue?vue&type=script&lang=js"
import style0 from "./HomeFeaturesTokens.vue?vue&type=style&index=0&id=95da436a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95da436a",
  null
  
)

export default component.exports